// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__1vBrr","content":"Page_content__33gQT","scrollingDisabled":"Page_scrollingDisabled__bWL0w"};